import { NavLink, Outlet } from "react-router-dom";
import { PageHeader } from "@/components/app/Common";
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

const SECTIONS = [
  ["connections", "Connections & keys"],
  ["branding", "Branding"],
  ["outbox", "Email outbox"],
  ["users", "Users"],
  ["audit-log", "Audit log"],
  ["task-library", "Task library"],
  ["interview-template", "Interview template"],
  ["assessment-templates", "Assessment templates"],
  ["fit-scoring", "Fit Score"],
  ["email-templates", "Email templates"],
  ["data-requests", "Data requests & retention"],
  ["privacy", "Privacy (DPDP)"],
  ["dpdp", "DPDP compliance"],
  ["incidents", "Incidents"],
  ["storage-purge", "Storage purge"],
  ["system", "System"],
];

export default function SettingsLayout() {
  return (
    <div className="space-y-6" data-testid="settings-page">
      <PageHeader title="Settings" subtitle="Organisation-wide settings. Only super admins can see this area." />
      <div className="grid gap-6 md:grid-cols-[200px_1fr]">
        <nav className="flex flex-row gap-1 overflow-x-auto md:sticky md:top-24 md:flex-col md:self-start" data-tour="pt-settings-nav" data-testid="settings-nav">
          {SECTIONS.map(([k, label]) => (
            <NavLink key={k} to={`/app/settings/${k}`} data-testid={`settings-nav-${k}`}
              className={({ isActive }) => cn("relative rounded-[5px] px-3 py-2 text-sm transition-colors duration-150",
                isActive ? "font-medium text-brand" : "text-ink-secondary hover:bg-white hover:text-ink")}>
              {({ isActive }) => <>{isActive && <motion.span layoutId="settings-nav-active" className="absolute inset-0 rounded-[5px] bg-brand-tint" transition={{ type: "spring", stiffness: 500, damping: 40 }} />}<span className="relative">{label}</span></>}
            </NavLink>
          ))}
        </nav>
        <div className="min-w-0"><Outlet /></div>
      </div>
    </div>
  );
}
